import axios from '../axios';
import api from '../api.mappings';
export class FeishuApi {
    sign(params) {
        return axios.get(api.feishu.sign, {
            params
        });
    }
    login(params) {
        return axios.get(api.feishu.login, {
            params
        });
    }
    // 待办登录逻辑， 由于待办跳转直接在浏览器打开，无法通过客户端拿到 code 换取免登 token, 所以单独处理
    undo(params) {
        return axios.get(api.feishu.undo, {
            params
        });
    }
}
